import { Box, CircularProgress, Typography } from '@mui/material';

type LoadingOverlayProps = {
  message?: string;
};

const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ message }) => (
  <Box
    sx={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(255, 255, 255, 0.7)', // semi-transparent overlay
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 2,
      zIndex: 1300 // Higher zIndex to overlay other components
    }}
  >
    <CircularProgress size={60} />
    {message ? (
      <Typography variant="body1" fontWeight={600} color="text.secondary">
        {message}
      </Typography>
    ) : null}
  </Box>
);

export default LoadingOverlay;
